<template>
  <div id="app">
    <Layout />
  </div>
</template>

<script>
import Layout from './views/layouts/layout.vue'

export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>

<style lang="scss">
@import '@/assets/fonts/list_card/iconfont.css';
@import '@/assets/fonts/production_card_ico/iconfont.css';
.tdt-left .tdt-control {
  display: none !important;
}
body {
  padding: 0;
  margin: 0;
}
.el-drawer__header {
  box-shadow: 0px 0px 12px 0px #77777777;
  margin-bottom: 0 !important;
  padding-bottom: 32px !important;
  z-index: 8 !important;
  span {
    font-size: 20px;
    font-weight: 900;
    color: #000;
  }
}
.el-drawer__body {
  position: relative;
}
.el-table thead {
  color: white !important;
}

.el-table-column--selection .cell {
  padding-right: 12px !important;
  padding-left: 12px !important;
  .el-checkbox__inner {
    width: 20px !important;
    height: 20px !important;
    display: flex !important;
    border: 1px solid #AAA;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
  }
  .el-checkbox__inner::before {
    position: unset !important;
    width: 20px;
    height: 3px !important;
  }
  .el-checkbox__inner::after {
    position: unset !important;
    height: 9px !important;
    width: 4px !important;
    border-width: 2px;
  }
}
.el-table .el-table__cell {
  div {
    font-size: 12px;
    text-align: left;
  }
}
.el-table__fixed-right-patch {
  background-color: transparent !important;
}
.el-table th.el-table__cell {
  background-color: #D7DEE6 !important;
  padding: 4px 0 !important;
  color: rgba(0, 0, 0, 0.9) !important;
  div {
    font-size: 14px !important;
    font-weight: 500;
  }

}

// 抽离 公共样式

.form-module-title {
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  font-weight: 400;
  color: #000;
  margin-top: 24px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.form-module-title::before {
  content: ' ';
  width: 5px;
  height: 26px;
  background-color: #1890FF;
  display: inline-block;
  margin-right: 12px;

}

.xhw-footer-form {
  height: calc(100vh - 80px - 80px);
  overflow-y: auto;
}

.form-footer {
  height: 80px;
  box-shadow: 0px 0px 12px 0px #77777777;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
}
.drawer-form-box {
  height: calc(100vh - 81px);
  box-sizing: border-box;
  padding: 0 0 80px;
  position: relative;
  .drawer-form-scroll {
    height: calc(100vh - 161px);
    overflow-y: auto;
    padding: 24px;
    box-sizing: border-box;
  }
  .drawer-form-footer {
    height: 80px;
    position: absolute;
    bottom: 0;
    width: 100%;
    box-shadow: 0 0 30px 4px #CCCCCC;
    padding: 0 32px;
    box-sizing: border-box;
    .drawer-form-footer-btns {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
.search-box {
  margin-bottom: 12px;
  display: flex;
  .filter-form {
    flex: 1;
    display: flex;
    gap: 4px;
    .filter-form-item {
      width: 200px;
    }
  }
}

.btn-iconfont {
  font-size: 12px !important;
}
.vue-treeselect__control {
  display: flex !important;
  height: 32px !important;
  box-sizing: border-box !important;
  align-items: center;
}
</style>
